export const TranslationsHE = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
        hi: 'हिन्दी',
        ko: '한국어',
        ru: 'Русский',
        tr: 'Türkçe',
        nl: 'Nederlands',
        pl: 'Polski',
        ms: 'Bahasa Melayu',
        ro: 'Română',
        cs: 'Čeština',
        sk: 'Slovenčina',
        hu: 'Magyar',
        ta: 'தமிழ்',
        te: 'తెలుగు',
        bn: 'বাংলা',
        zht: '繁體中文',
        he: 'עברית',
        sq: 'Shqip',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
        hi: 'HI',
        ko: 'KO',
        ru: 'RU',
        tr: 'TR',
        nl: 'NL',
        pl: 'PL',
        ms: 'MS',
        ro: 'RO',
        cs: 'CS',
        sk: 'SK',
        hu: 'HU',
        ta: 'TA',
        te: 'TE',
        bn: 'BN',
        zht: 'ZHT',
        he: 'HE',
        sq: 'SQ',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
        hi: 'HIN',
        ko: 'KOR',
        ru: 'RUS',
        tr: 'TUR',
        nl: 'NLD',
        pl: 'POL',
        ms: 'MSA',
        ro: 'RON',
        cs: 'CES',
        sk: 'SLK',
        hu: 'HUN',
        ta: 'TAM',
        te: 'TEL',
        bn: 'BEN',
        zht: '繁體',
        he: 'HEB',
        sq: 'SQI',
    },
    // BASE
    phrases: {
        order_online: 'הזמנה אונליין',
        cart: 'עגלת קניות',
        open_24: '24 שעות',
        closed: 'סגור',
        free: 'חינם',
        something_went_wrong: 'משהו השתבש',
        try_again: 'נסה שוב',
    },
    constants: {
        calendar: {
            days: {
                monday: 'יום שני',
                tuesday: 'יום שלישי',
                wednesday: 'יום רביעי',
                thursday: 'יום חמישי',
                friday: 'יום שישי',
                saturday: 'שבת',
                sunday: 'יום ראשון',
            },
        },
        services: {
            pickup: 'איסוף עצמי',
            delivery: 'משלוח',
            dine_in: 'אכילה במקום',
            table_booking: 'הזמנת שולחן',
        },
        payment: {
            method: {
                cash: 'מזומן',
                card: 'כרטיס',
                stripe: 'כרטיס אשראי',
                paypal: 'PayPal',
                cardconnect: 'כרטיס אשראי',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                razor_pay: 'Razor Pay',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                custom: 'Custom',
                red_dot: 'Red Dot Payment',
                gkash: 'Gkash',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva Wallet',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                authorized: 'Authorize.net',
            },
            // BACKENDMETHODNAMES
            backend_method: {
                cash: 'מזומן',
                card: 'כרטיס',
                stripe: 'Stripe',
                paypal: 'PayPal',
                cardconnect: 'CardConnect',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                bambora_na: 'Worldline',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                stripe_digital_wallet: 'Google/Apple Pay',
                razor_pay: 'Razor Pay',
                gravity: 'Gravity',
                authorized: 'Authorize.net',
                elavon: 'Elavon',
                red_dot: 'Red Dot Payment',
                gkash: 'Gkash',
                custom: 'Custom',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva Wallet',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                nuvei: 'Nuvei',
                ONLINE: 'Online',
                online: 'Online',
            },
            status: {
                success: 'הצלחה',
                pending: 'ממתין',
                error: 'שגיאה',
                refunded: 'הוחזר',
                refunding: 'מוחזר',
                partial_refunded: 'הוחזר חלקית',
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: 'הסר',
                drop_here: 'גרור קבצים לכאן או לחץ לבחירה',
                accepts: 'מקבל קבצים מסוג {{fileTypes}}',
                errors: {
                    max_files: 'מקסימום {{number}} מותר',
                    max_size: 'גודל קובץ מקסימלי של {{kilobytes}} KB',
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: 'החנות סגורה כעת ולא ניתן להזמין לאכילה במקום לעכשיו. ניתן לנסות להזמין לתאריך ושעה מאוחרים יותר',
            },
            buttons: {
                order: {
                    book_order: 'הזמנת שולחן / הזמנה אונליין',
                    order_online: 'הזמנה אונליין',
                    book_table: 'הזמנת שולחן',
                    order: 'הזמנה',
                    book: 'הזמנה',
                    cart: 'עגלת קניות',
                    restart: 'התחל מחדש',
                    closed: 'החנות סגורה',
                    not_accepting: 'לא מקבלים הזמנות',
                },
            },
        },
        modals: {
            auth: {
                login: 'התחברות',
                register: 'הרשמה',
                register_commence: 'המשך',
                register_complete: 'יצירת חשבון',
                register_confirmation_sent: 'קוד אימות נשלח לכתובת הדוא"ל שלך. הזן אותו למטה כדי להמשיך',
                register_confirmation_resent: 'קוד האימות נשלח שוב, בדוק בתיקיית הספאם או התחל את התהליך מחדש',
                register_restart: 'התחל מחדש',
                register_resend_code: 'שלח קוד שוב',
                register_confirmation_code_subject: 'קוד אימות בדוא"ל',
                register_confirmation_code_email: 'קוד האימות שלך הוא {{confirmation_code}} (פג תוקף בעוד 24 שעות)',
                login_placeholder: 'דוא"ל',
                password_placeholder: 'סיסמה',
                confirm_password_placeholder: 'אימות סיסמה',
                confirmation_code_placeholder: 'קוד אימות בדוא"ל',
                accept_terms: 'קבלת תנאים והגבלות',
                accept_terms_view: 'צפייה',
                login_facebook: 'התחברות עם Facebook',
                login_google: 'התחברות עם Google',
                benefits: 'התחבר או צור חשבון כדי לשמור את כל ההזמנות שלך',
                logged_in: 'התחברת בהצלחה',
                logged_out: 'התנתקת',
                password_reset: {
                    init_button: 'שליחת דוא"ל לאיפוס סיסמה',
                    init_success: 'קישור לאיפוס סיסמה נשלח לדוא"ל שלך',
                    complete_button: 'איפוס סיסמה',
                    complete_success: 'הסיסמה אופסה בהצלחה, התחבר עם הסיסמה החדשה',
                    forgot_password_text: 'שכחת את הסיסמה? ',
                    forgot_password_link: 'איפוס סיסמה',
                    remember_password_text: 'זוכר את הסיסמה? ',
                    remember_password_link: 'חזרה',
                    invalid_title: 'קישור איפוס סיסמה לא תקין',
                    invalid_description: 'קישור איפוס הסיסמה אינו תקין, בקש קישור חדש',
                    invalid_link: 'עבור להתחברות',
                    title: 'איפוס סיסמה',
                    description: 'הזן סיסמה חדשה לחשבון שלך',
                },
                error_generic: 'משהו השתבש, נסה שוב או צור קשר',
                error_accept_terms: 'אנא קבל את התנאים וההגבלות',
                error_password_length: 'מינימום 6 תווים לסיסמה',
                error_social: 'משהו השתבש, נסה שוב או צור קשר',
                error_confirmation_code: 'קוד אימות לא תקין',
                error_invalid_code: 'קוד אימות לא תקין',
                error_exists: 'המשתמש כבר קיים',
                error_invalid_email_pass: 'כתובת דוא"ל או סיסמה לא תקינים',
                error_password_no_match: 'הסיסמאות אינן תואמות',
                error_user_not_found: 'אין משתמש עם כתובת דוא"ל זו',
                error_invalid_email: 'כתובת דוא"ל לא תקינה',
                error_invalid_reset_token: 'קישור איפוס לא תקין, בקש קישור אחר',
            },
            booking: {
                form: {
                    name: 'שם מלא',
                    email: 'כתובת דוא"ל',
                    phone: 'מספר טלפון',
                    number_of_people: 'מספר אנשים',
                    number_of_people_max: 'מספר אנשים (מקסימום {{max_people}})',
                    number_of_people_min: 'מספר אנשים (מינימום {{min_people}})',
                    number_of_people_max_min: 'מספר אנשים (בין {{min_people}} ל-{{max_people}})',
                    notes: 'הערות / בקשות מיוחדות',
                    submit: 'שליחת בקשת הזמנה',
                    email_optional: '(אופציונלי)',
                    date: 'תאריך',
                    duration: 'משך',
                    seating: 'שעות פנויות',
                    number_of_guests: 'מספר אורחים',
                    notes_placeholder: 'אלרגיות, אירוע, העדפת ישיבה',
                    reserving: 'מבצע הזמנה...',
                    reserve_table: 'הזמן שולחן',
                    please_choose_a_date_and_time: 'בחר תאריך ושעה.',
                    invalid_people: 'מספר האנשים חייב להיות בין {{min}} ל-{{max}}.',
                    party_size_max_fallback: 'המקסימום המותר',
                    loading_available_times: 'טוען שעות פנויות…',
                    select_a_date_to_see_available_times: 'בחר תאריך כדי לראות שעות פנויות.',
                    no_times_available_for_this_date: 'אין שעות פנויות לתאריך זה. בחר יום אחר.',
                    shift: 'משמרת',
                    service_times: 'שעות פעילות',
                    new_shift: 'משמרת חדשה',
                    time: 'שעה',
                    times: 'שעות',
                    unavailable: 'לא זמין',
                    available: 'זמין',
                    required_name: 'הזן את שמך.',
                    required_phone: 'הזן את מספר הטלפון שלך.',
                    required_email: 'הזן את כתובת האימייל שלך.',
                    invalid_email: 'הזן כתובת אימייל תקינה.',
                    required_terms: 'קבל את התנאים לפני ההזמנה.',
                    reservation_is_unavailable: 'ההזמנה אינה זמינה.',
                    please_contact_the_restaurant_directly: 'פנה למסעדה ישירות.',
                    almost_done: 'כמעט סיימנו',
                    your_details: 'הפרטים שלך',
                    tell_us_who_s_coming: 'ספר לנו מי מגיע כדי שנוכל לאשר את ההזמנה.',
                    book_your_table: 'הזמן את השולחן שלך',
                    choose_a_time_that_works_for_you: 'בחר שעה שנוחה לך.',
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: 'שלח את בקשת ההזמנה והמסעדה תטפל בשאר.',
                    select_date: 'בחר תאריך',
                    standard: 'רגיל',
                    minutes: 'דקות',
                    next: 'הבא →',
                    back: '← חזרה',
                    accept_terms: 'אני מקבל את התנאים וההגבלות.',
                    info_1: 'תקבל הודעה בדוא"ל כאשר ההזמנה שלך תאושר או תידחה',
                },
                errors: {
                    not_found: 'ההזמנה לא קיימת. ייתכן שנמחקה',
                    generic: 'משהו השתבש, רענן את הדף או צור קשר',
                    something_went_wrong: 'משהו השתבש',
                    accept_terms: 'אנא קבל את התנאים וההגבלות',
                    required_phone: 'אנא הזן את מספר הטלפון שלך',
                    required_email: 'אנא הזן את כתובת הדוא"ל שלך',
                    required_zip: 'אנא הזן את מיקוד החיוב שלך',
                    required_name: 'אנא הזן את שמך',
                    invalid_email: 'אנא הזן כתובת דוא"ל תקינה',
                    invalid_phone: 'אנא הזן מספר טלפון תקין',
                    invalid_people: 'מספר אנשים לא תקין',
                    missing_custom_fields: 'אנא מלא את כל השדות הנדרשים.',
                    booking_capacity_threshold: 'אנחנו מלאים בשעה זו. נסה שעה אחרת.',
                    slot_unavailable: 'אנחנו מלאים למספר אנשים זה. נסה שעה אחרת.',
                    booking_date_paused: 'ההזמנות מושהות לתאריך זה. בחר יום אחר.',
                    invalid_table_assignment: 'השולחנות האלה לא יכולים להכיל את הקבוצה שלך. בחר שעה אחרת.',
                    exceeded_order_limit: 'יותר מדי בקשות הזמנה. נסה שוב מאוחר יותר.',
                    validation_failed_recaptcha_v3: 'זוהתה תעבורה חריגה. האם אתה משתמש ב-VPN? השלם את האימות למעלה ונסה שוב.',
                    validation_failed_recaptcha_v2: 'לא ניתן היה להתחיל את ההזמנה. נסה שוב או השתמש בדרך אחרת. אם אתה משתמש ב-VPN, נסה לכבות אותו תחילה.',
                    booking_already_exists: 'ההזמנה הזו כבר נשלחה. בדוק את האימייל שלך או פתח את קישור ההזמנה.',
                    invalid_party_size: 'בחר מספר אנשים תקין.',
                    invalid_request: 'בקשה לא תקינה. רענן את הדף ונסה שוב.',
                    table_booking_unavailable: 'הזמנת שולחן אינה זמינה.',
                },
            },
            cart: {
                title: 'עגלת קניות',
                proceed_to_checkout: 'המשך לתשלום',
                edit_dish: 'עריכה',
                remove_dish: 'הסר',
                no_items_1: 'אין פריטים בעגלה',
                no_items_2: 'הוסף פריטים כדי להמשיך',
                free_delivery_notice: 'משלוח חינם להזמנות מעל {{value, currency}}',
                errors: {
                    min_order_promo: 'נדרש ערך עגלה מינימלי של {{value, currency}} לפני החלת מבצע זה',
                    min_order_delivery: 'ערך עגלה מינימלי של {{value, currency}} למשלוח',
                },
                promo: {
                    heading: 'קוד מבצע',
                    placeholder: 'הזן את קוד המבצע',
                    add: 'הוסף קוד',
                    title: 'מבצע {{name}} נוסף לעגלה',
                    fixed_discount: '{{value, currency}} הנחה',
                    percent_discount: '{{value}}% הנחה',
                    added_to_cart: 'מבצע נוסף לעגלה',
                    errors: {
                        not_found: 'מבצע לא נמצא',
                        disabled: 'המבצע מושבת',
                        not_available: 'המבצע אינו זמין כעת',
                        not_eligible: 'אינך זכאי להחיל קוד מבצע',
                        not_available_time: 'המבצע אינו חל על שעה זו',
                        logged_in_only: 'יש להתחבר כדי להשתמש במבצע זה',
                        already_used: 'כבר השתמשת במבצע זה',
                        invalid: 'מבצע זה אינו תקף עוד',
                        invalid_service: 'מבצע זה אינו תקף לשירות שבחרת',
                        later_only: 'תקף להזמנות מראש בלבד',
                        now_only: 'תקף רק להזמנות לעכשיו, לא להזמנות מראש',
                        generic: 'אופס... משהו השתבש והדבר נרשם',
                        dishes_required_multi: 'מבצע זה יוחל רק כאשר פריטים מסוימים יתווספו לעגלה',
                        dishes_required_single: 'מבצע זה יוחל רק עבור \'{{dish}}\'',
                    },
                },
                tip: {
                    title: 'טיפ להזמנה',
                    placeholder: 'הוסף טיפ להזמנה',
                },
            },
            free_items_promo: {
                title: 'פריטים חינם',
                usage_confirmation: {
                    question: 'אתה זכאי לפריטים חינם. האם תרצה לראות ולהוסיף אותם?',
                    cancellation: 'לא, איני רוצה פריטים חינם',
                    acceptance: 'כן',
                },
                free_items_selection: {
                    multiple: {
                        description: 'בחר {{number}} פריט(ים) חינם',
                    },
                    single: {
                        description: 'בחר פריט חינם',
                    },
                    confirm_button: 'אישור',
                },
            },
            checkout: {
                title: 'תשלום',
                subtitle: 'אשר את פרטי ההזמנה',
                details: {
                    service: 'שירות',
                    due: 'מועד',
                    due_now_asap: 'עכשיו / בהקדם',
                    address: 'כתובת משלוח',
                    total: 'סה"כ',
                    table: 'שולחן',
                    store_location: 'כתובת החנות',
                },
                customer: {
                    title: 'לקוח',
                    subtitle: 'התחבר כדי לשמור את ההזמנה והפרטים שלך',
                    button: 'התחברות',
                    name: 'שם מלא',
                    email: 'דוא"ל',
                    phone: 'טלפון',
                    phone_important: 'טלפון (חשוב)',
                    notes: 'הערות להזמנה',
                    delivery_notes: 'הוראות משלוח / הערות להזמנה',
                    uber_delivery_notes_too_long: 'הערות משלוח חייבות להיות {{max}} תווים או פחות כדי לבצע את ההזמנה.',
                    uber_delivery_notes_near_limit: 'הגעת למגבלת {{max}} תווים. קצר את ההערות כדי לבצע את ההזמנה.',
                    optional: 'אופציונלי',
                },
                payment: {
                    title: 'אמצעי תשלום',
                    qr_modal_help: 'השתמש באפליקציית {{app}} שלך כדי לסרוק את קוד ה-QR ולהשלים את התשלום. לאחר שהתשלום הושלם באפליקציה, ניתן לסגור חלון זה. אל תסגור חלון זה אם לא סיימת את תהליך התשלום.',
                    switch_to_app_help: 'בלחיצה על הכפתור למטה, אפליקציית {{app}} תיפתח אוטומטית להשלמת התשלום. לאחר שהתשלום הושלם באפליקציה, ניתן לסגור חלון זה. אל תסגור חלון זה אם לא סיימת את תהליך התשלום.',
                    open_app: 'פתח את אפליקציית {{app}}',
                    continue: 'המשך',
                    continue_to_payment: 'המשך ל-{{method}}',
                    back_to_cart: 'חזרה לעגלה',
                },
                accept_terms: 'קבלת תנאים והגבלות',
                accept_terms_view: 'צפייה',
                processing_order: 'מעבד הזמנה',
                warning: {
                    different_payment_currency: 'מחירי החנות ב-{{store_currency}} אך אמצעי התשלום ב-{{payment_currency}}',
                    closing_soon: 'נסגרים בקרוב, יש להזמין תוך {{value}} דקות',
                    closed: 'מצטערים, שירות זה נסגר ולא מקבלים הזמנות',
                    paused: 'מצטערים, שירות זה הושהה ולא מקבלים הזמנות כרגע',
                    expired: 'לא ניתן עוד לספק את ההזמנה במועד שבחרת. בחר תאריך או שעה מאוחרים יותר',
                },
                errors: {
                    walletly_promo: 'יש שגיאה במבצע Walletly, נסה מבצע אחר!',
                    stripe_generic: 'שגיאת כרטיס אשראי, נסה שוב או בחר אמצעי אחר',
                    validation_failed: 'לא ניתן לקבל תשלום זה כעת. נסה שוב מאוחר יותר או בחר אמצעי תשלום אחר.',
                    validation_failed_recaptcha_v3: 'זוהה תעבורה חריגה. האם אתה משתמש ב-VPN? השלם את האתגר למעלה ונסה שוב.',
                    validation_failed_recaptcha_v2: 'לא הצלחנו להתחיל את התשלום. נסה שוב או השתמש באמצעי אחר. אם אתה משתמש ב-VPN, נסה לכבות אותו תחילה.',
                    stripe_loading_fail: 'שגיאה בטעינת טופס התשלום, נסה שוב',
                    something_went_wrong: 'משהו השתבש',
                    paypal_generic: 'משהו השתבש עם PayPal, נסה שוב או בחר אמצעי תשלום אחר',
                    payment_fail: 'התשלום נכשל, נסה שוב או בחר אמצעי תשלום אחר',
                    payment_cancelled: 'התשלום בוטל, נסה שוב או בחר אמצעי תשלום אחר',
                    payment_error: 'שגיאה בעיבוד תשלום אונליין, נסה שוב או בחר אמצעי תשלום אחר',
                    payment_declined: 'אמצעי התשלום שלך נדחה',
                    card_declined: 'הכרטיס שלך נדחה ולא ניתן לעבד את התשלום',
                    store_closed: 'החנות סגורה ולא מקבלת עוד הזמנות',
                    accept_terms: 'אנא קבל את התנאים וההגבלות',
                    required_payment: 'אנא בחר אמצעי תשלום',
                    required_phone: 'אנא הזן את מספר הטלפון שלך',
                    required_email: 'אנא הזן את כתובת הדוא"ל שלך',
                    required_zip: 'אנא הזן את מיקוד החיוב שלך',
                    required_name: 'אנא הזן את שמך',
                    invalid_email: 'אנא הזן כתובת דוא"ל תקינה',
                    invalid_phone: 'אנא הזן מספר טלפון תקין',
                    invalid_cc_number: 'מספר כרטיס האשראי שלך אינו תקין',
                    invalid_order_amount: 'נדרש סכום מינימלי לאמצעי תשלום זה',
                    retry_cc_number: 'משהו השתבש, הזן שוב את מספר כרטיס האשראי ונסה שוב',
                    closed: 'החנות סגורה ולא מקבלת הזמנות',
                    promo_login_required: 'יש להתחבר כדי להשתמש במבצע זה',
                    promo_used: 'כבר השתמשת במבצע זה',
                    promo_by_payment_method_not_applicable: 'המבצע אינו חל על אמצעי התשלום שנבחר.',
                    missing_custom_checkout_fields: 'אנא מלא את כל השדות הנדרשים.',
                    delivery_unavailable: 'שירות המשלוחים אולי אינו זמין כעת. שקול להזמין באיסוף עצמי במקום.',
                    required_delivery_provider: 'אנא בחר שירות משלוח.',
                    required_delivery_quotation: 'הערכת המשלוח פגה.',
                    exceeded_order_limit: 'אנחנו מקבלים הרבה הזמנות כרגע. בחר שעה מאוחרת יותר.',
                    exceeded_order_limit_later: 'לא ניתן עוד לספק את ההזמנה במועד שבחרת. בחר תאריך או שעה מאוחרים יותר',
                    dish_error: '{{items}} אינם זמינים עוד. רענן או הסר מהעגלה.',
                    promo_max_uses_exceeded: 'קוד מבצע זה הגיע למגבלת השימוש ואינו זמין עוד.',
                },
                button: {
                    continue: 'המשך לתשלום',
                    place_order: 'בצע הזמנה',
                    update_order: 'עדכן הזמנה',
                },
                delivery_estimation: {
                    title: 'הערכת משלוח',
                    details: {
                        provider: 'ספק משלוחים',
                        estimated_fee: 'עמלה משוערת',
                        estimated_total_fee: 'סה"כ דמי משלוח',
                        estimated_discount_fee: 'הנחה על דמי משלוח',
                        previous_estimated_fee: 'עמלה משוערת קודמת',
                        tips: 'טיפים',
                        estimated_delivery_time: 'זמן משלוח משוער',
                        uber_new_estimation: 'בקש הערכה חדשה',
                        uber_new_estimation_success: 'הערכת משלוח Uber חדשה הוחלה.',
                        uber_estimation_expired: 'הערכת המשלוח פגה',
                        uber_price: 'אנחנו שומרים את מחיר Uber',
                        uber_need_time: 'אני צריך עוד זמן',
                        uber_delivery_notes_too_long: 'הערות משלוח חייבות להיות {{max}} תווים או פחות כדי לבקש משלוח Uber.',
                        lalamove_price: 'אנחנו שומרים את דמי המשלוח של Lalamove',
                        lalamove_new_estimation_success: 'הערכת משלוח Lalamove חדשה הוחלה.',
                        lalamove_estimation_expired: 'הערכת המשלוח פגה',
                        lalamove_need_time: 'אני צריך עוד זמן',
                        lalamove_new_estimation: 'בקש הערכה חדשה',
                    },
                    quotation_error: 'משהו השתבש בחישוב הערכת המשלוח.',
                },
            },
            customer: {
                age_v: {
                    title: 'אימות גיל',
                    required_for_items: 'נדרש להזמנת פריטים מסוימים',
                    min_age: 'גיל מינימלי: {{age}} שנים',
                    est_time: 'זמן אימות משוער: {{time}} שעות',
                    upload_description: 'העלה את תעודת הזהות שלך למטה לאימות. תקבל הודעה בדוא"ל לאחר האימות. ניתן להעלות עד 2 תמונות בגודל מקסימלי של 2 MB כל אחת',
                    pending_description_1: 'תודה על שליחת המסמכים. תקבל הודעה בדוא"ל כאשר תאושר',
                    pending_description_2: 'רענן את הדף לעדכון סטטוס האימות. זמן אימות משוער הוא {{time}} שעות',
                    approved_description: 'החשבון שלך אומת וניתן להזמין מתפריטים מוגבלים',
                    rejected_description: 'תעודת הזהות שלך נדחתה. אם ברצונך לנסות שוב, העלה מחדש את התעודה',
                    upload: 'העלאה',
                    reupload: 'העלאת מסמכים מחדש',
                    go_back: 'חזרה',
                    view_document: 'צפה במסמך {{number}}',
                    status: {
                        unverified: 'לא מאומת',
                        pending: 'ממתין לאישור',
                        approved: 'אומת בהצלחה',
                        rejected: 'נדחה',
                    },
                },
                headings: {
                    sessions: 'סשנים',
                    orders: 'הזמנה',
                    spend: 'הוצאה',
                    order_history: 'היסטוריית הזמנות',
                    loyalty: 'נאמנות',
                    loyalty_points: 'נקודות נאמנות',
                    added: 'מבצע נוסף.',
                },
                loyalty_errors: {
                    invalid_cart_items: 'בחר פריט לפני מימוש!',
                    not_found: 'מבצע לא נמצא!',
                    already_exists: 'מבצע כבר קיים!',
                    try_again: 'לא ניתן להחיל מבצע זה. נסה שוב!',
                },
            },
            custom_payment: {
                title: 'טופס תשלום {{name}}',
                description: 'הגעת לטופס התשלום האונליין שלנו. מלא את השדות למטה לביצוע תשלום. אם לא יוזן סכום, הפרטים שלך יישמרו אך לא תחויב.',
                disabled: 'דף תשלום זה לא הוגדר כראוי. צור קשר עם בעל האתר לתיקון הבעיה.',
                success: 'התשלום שלך עובד בהצלחה והפרטים שלך נשמרו. תודה',
                back: 'חזרה לדף הבית',
                fields: {
                    name: 'שם מלא',
                    email: 'כתובת דוא"ל',
                    reference: 'אסמכתת תשלום',
                    amount: 'סכום ($)',
                    name_on_card: 'שם על הכרטיס',
                    submit: 'שליחת תשלום',
                },
                warning: {
                    currency: 'הערה: סכום התשלום ב-{{actual}}, לא ב-{{default}}',
                },
                errors: {
                    generic: 'משהו השתבש, נסה שוב או צור קשר',
                    stripe_generic: 'שגיאת כרטיס אשראי, רענן את הדף ונסה שוב',
                    payment_fail: 'התשלום נכשל, נסה שוב או בחר אמצעי תשלום אחר',
                    payment_cancelled: 'התשלום בוטל, נסה שוב או בחר אמצעי תשלום אחר',
                    payment_error: 'שגיאה בעיבוד תשלום אונליין, נסה שוב או בחר אמצעי תשלום אחר',
                    payment_declined: 'אמצעי התשלום שלך נדחה',
                    card_declined: 'הכרטיס שלך נדחה ולא ניתן לעבד את התשלום',
                    promo_max_uses_exceeded: 'קוד מבצע זה הגיע למגבלת השימוש ואינו זמין עוד.',
                },
            },
            dish: {
                add: 'הוסף לעגלה',
                edit: 'עדכן פריט',
                notes: 'הוראות מיוחדות...',
                ingredients: {
                    title: 'מרכיבים',
                    uncheck_remove: 'בטל סימון להסרה',
                },
                ingredients_title: 'מרכיבים',
                combo: {
                    choose_dish: 'בחר פריט',
                },
                option_sets: {
                    conditions: {
                        select_one: 'בחר אחד (חובה)',
                        select_one_optional: 'בחר אחד (אופציונלי)',
                        select_between: 'בחר בין {{min}} - {{max}} (חובה)',
                        select_at_least: 'בחר לפחות {{qty}} (חובה)',
                        select_up_to: 'בחר עד {{qty}} (אופציונלי)',
                        select_multiple_optional: 'בחר מספר (אופציונלי)',
                        select_multiple: 'בחר מספר (חובה)',
                        free_amount: '{{qty}} ראשונים חינם / {{selected}} נבחרו',
                    },
                    points: {
                        none_consumed: 'ניתן לבחור מקסימום {{maxFree}} אפשרויות בחינם',
                        less_than_total_points: 'ניתן לבחור עוד אפשרויות בחינם',
                        greather_than_total_points: 'ניתן לבחור עוד אפשרויות בתשלום נוסף',
                    },
                },
                error: 'תקן את האפשרויות המסומנות באדום',
                added_to_cart: 'פריט נוסף לעגלה',
            },
            map: {
                zone_fee: 'דמי משלוח',
                view_in_google: 'צפה ב-Google Maps',
            },
            portal_go_back: {
                title: 'לחזור לחיפוש מסעדות?',
                description: 'כל הפריטים בעגלה יאבדו',
                cancel: 'ביטול',
                proceed: 'חזרה',
            },
            order: {
                config: {
                    services: {
                        title: 'בחר שירות',
                        table_booking: 'הזמנת שולחן',
                    },
                    address_custom: {
                        input_placeholder: 'הזן את כתובתך',
                    },
                    address: {
                        input_placeholder: 'מצא את כתובת המשלוח',
                        extras_placeholder: 'מספר דירה, שם בניין, הוראות משלוח וכו\'...',
                        search_placeholder: 'חפש את כתובתך',
                        search_input_placeholder: 'הקלד לחיפוש',
                        no_address_found: 'לא נמצאו כתובות. נסה להקליד יותר מ-5 תווים',
                        not_found: 'כתובת משלוח לא נמצאה או לא תקינה, נסה שוב',
                        not_delivering: 'איננו מספקים כרגע לכתובת זו',
                        not_in_range: 'הכתובת שלך מחוץ לטווח מיקום החנות',
                        not_in_zone: 'הכתובת שלך אינה באזור משלוח פעיל',
                        no_number: 'הכתובת חייבת לכלול מספר בית',
                        location_permission: 'לאפשר לאתר זה גישה למיקום הנוכחי שלך?',
                        location_permission_warning: 'לא ניתן לגשת למיקום הנוכחי. הפעל שירותי מיקום במכשיר ובדפדפן. הנה כמה הפניות:',
                        pick_location: 'בחר את המיקום שלך',
                        pick_location_help_text: 'גרור את הסמן לבחירת מיקום על המפה.',
                        use_current_location: 'השתמש במיקום הנוכחי',
                        locate_on_map: 'אתר על המפה',
                    },
                    datetime: {
                        title: 'מתי תרצה את ההזמנה',
                        due_now: 'עכשיו',
                        due_later: 'מאוחר יותר',
                        service_not_available: 'מצטערים, איננו מקבלים כרגע הזמנות ל-{{service}}',
                        currently_closed: '{{service}} סגור כרגע אך ניתן להזמין למועד מאוחר',
                        due_unavailable: 'לא זמין',
                        due_closed: 'סגור',
                        select_date: 'בחר תאריך',
                        select_time: 'בחר שעה',
                        select_order_date: 'בחר תאריך הזמנה',
                        select_order_time: 'בחר שעת הזמנה',
                        select_order_date_time: 'בחר תאריך/שעת הזמנה',
                        select_booking_date: 'בחר תאריך הזמנה',
                        select_booking_time: 'בחר שעת הזמנה',
                        no_times_available: 'אין שעות זמינות לבחירה',
                        date_today: '(היום)',
                        date_closed: '(סגור)',
                        date_bookings_paused: '(ההזמנות מושהות)',
                        time_slot_closed: 'סגור',
                    },
                    number_of_people: {
                        placeholder: 'מספר אנשים',
                    },
                    table: {
                        select: 'בחר שולחן',
                        select_popup_title: 'בחר את השולחן שלך',
                        password: 'סיסמת שולחן',
                        password_warning: 'הזן את סיסמת השולחן כדי להמשיך',
                    },
                    warning: {
                        closed: 'מצטערים, אנחנו סגורים / לא מקבלים הזמנות',
                        not_available: 'מצטערים, איננו מקבלים כרגע הזמנות',
                    },
                    eta: {
                        delivery: `זמן משלוח משוער הוא כ-{{minutesToCustomer}} דקות`,
                        pickup: `ההזמנה תהיה מוכנה בעוד כ-{{minutesToCustomer}} דקות`,
                    },
                    start_button: 'התחל הזמנה',
                },
                history: {
                    invalid: 'לא זכאי להזמנה חוזרת כיוון שחלק מהפריטים שונו או אינם זמינים עוד',
                },
                reorder: {
                    title: 'הזמנה חוזרת מהירה',
                    description: 'הזמן בקלות פריטים מהזמנות קודמות',
                },
            },
            receipt: {
                errors: {
                    not_found: 'ההזמנה לא נמצאה, רענן את הדף ונסה שוב',
                    booking_not_found: 'ההזמנה לא קיימת. ייתכן שהיא נמחקה',
                    generic: 'משהו השתבש, רענן את הדף או צור קשר',
                },
                connection: {
                    connected: 'עדכונים בזמן אמת',
                    connecting: 'מתחבר לעדכונים בזמן אמת',
                    disconnected: 'עדכונים בזמן אמת מנותקים',
                },
            },
            warnings: {
                logout: {
                    pretitle: 'אזהרה',
                    title: 'התנתקות',
                    body: 'התנתקות תסיר את כל הפריטים שנוספו לעגלה',
                    cancel: 'ביטול',
                    proceed: 'המשך',
                },
                order_restart: {
                    warning: 'אזהרה',
                    title: 'שינוי פרטי הזמנה',
                    body: 'שינוי פרטי ההזמנה יסיר את הפריטים בעגלה כיוון שפריטים מסוימים עלולים להיות לא זמינים',
                    cancel: 'ביטול',
                    proceed: 'המשך',
                },
                order_expired: {
                    subtitle: 'חשוב',
                    title: 'ההזמנה שונתה לעכשיו',
                    description: 'המועד שבחרת קרוב מאוד. לכן ההזמנה שלך שונתה לעכשיו / בהקדם',
                    button: 'אישור',
                },
                order_expiring: {
                    subtitle: 'חשוב',
                    title: 'מועד ההזמנה עומד לפוג בקרוב',
                    description: 'יש להזמין לפני {{time, timeFromTimestamp}} אחרת ההזמנה לא תהיה תקפה',
                    button: 'אישור',
                },
                location_permission: {
                    cancel: 'ביטול',
                    proceed: 'המשך',
                },
            },
            card_payment_authentication: {
                title: 'אימות תשלום',
                note: 'השאר חלון זה פתוח עד שתשלים את תהליך האימות מהבנק.',
            },
            maps: {
                cancel: 'ביטול',
                use_location: 'השתמש במיקום',
            },
            app_refresh: {
                refresh: 'רענון',
                title: 'רענון החנות',
                description: 'החנות שלנו עודכנה. רענן את הדפדפן כדי לגשת לגרסה העדכנית. לאחר הרענון, ייתכן שתצטרך לפתוח מחדש את העגלה כדי להמשיך לתשלום.',
            },
        },
        sections: {
            nav_top: {
                guest: 'אורח',
                login: 'התחברות',
                login_signup: 'התחברות / הרשמה',
                logout: 'התנתקות',
            },
            menus: {
                info: {
                    no_menus: 'אין תפריטים זמינים כרגע',
                    restrictions: 'הגבלות תפריט',
                    not_available: 'תפריט לא זמין',
                    unavailable: {
                        times: 'תפריט לא זמין, דרישות ההזמנה שלך אינן תואמות למטה',
                        services: 'תפריט לא זמין, דרישות ההזמנה שלך אינן תואמות למטה',
                        hours: 'תפריט לא זמין, שעות ההזמנה שלך אינן בתוך שעות הפעילות של תפריט זה',
                        pre_order: 'תפריט לא זמין, ההזמנה שלך אינה תואמת לדרישות ההזמנה מראש',
                        age: 'תפריט לא זמין, יש להתחבר עם חשבון מאומת גיל כדי להזמין מתפריט זה',
                    },
                    services: {
                        title: 'דרישות הזמנה',
                        pickup: 'איסופים',
                        delivery: 'משלוחים',
                        dine_in: 'אכילה במקום',
                    },
                    times: {
                        now: 'ללא הזמנות מראש',
                        later: 'הזמנות מראש בלבד',
                    },
                    hours: {
                        title: 'שעות זמינות',
                    },
                    preorder: {
                        title: 'דרישות הזמנה מראש',
                        days_in_advance: 'יש להזמין {{days}} ימים מראש',
                        cutoff_time: 'מועד אחרון ביום האחרון ב-{{time, timeFromTime}}',
                    },
                    age_restricted: {
                        title: 'מוגבל גיל',
                        approved: 'החשבון שלך מאומת וניתן להזמין מתפריט זה',
                        rejected: 'נדרש אימות גיל להזמנה. צור חשבון והעלה תעודת זהות',
                    },
                },
                search: {
                    title: 'גלוש בפריטי התפריט',
                    no_result: 'לא נמצאו תוצאות. לנסות מונח חיפוש אחר?',
                    placeholder: 'מה אתה מחפש?',
                },
            },
            category: {
                restrictions: 'הגבלות קטגוריה',
                not_available: 'קטגוריה לא זמינה',
                unavailable: {
                    services: 'קטגוריה לא זמינה, דרישות ההזמנה שלך אינן תואמות למטה',
                    hours: 'קטגוריה לא זמינה, שעות ההזמנה שלך אינן בתוך שעות הפעילות של קטגוריה זו',
                },
            },
            info: {
                location: {
                    title: 'מיקום',
                    view_map: 'צפה במפה',
                    phone: 'טלפון',
                },
                hours: {
                    title: 'שעות פתיחה',
                    title_special: 'שעות פתיחה מיוחדות',
                },
                services: {
                    title: 'שירותים',
                    notes: 'הערות',
                    delivery: {
                        ranges: 'טווחי משלוח',
                        zones: 'אזורי משלוח',
                        view_zones: 'צפה באזורים על המפה',
                        fee: 'דמי משלוח',
                        fee_varies: 'משתנה, מוצג בעגלה',
                        min_order: 'הזמנה מינימלית',
                        no_min_order: 'ללא הזמנה מינימלית',
                        free_amount: 'סכום למשלוח חינם',
                    },
                },
            },
            contact: {
                title: 'צור קשר',
                name: 'שם',
                email: 'דוא"ל',
                phone: 'מספר טלפון',
                message: 'הזן את הודעתך...',
                send: 'שלח הודעה',
                success: 'ההודעה שלך נשלחה בהצלחה',
                error: 'משהו השתבש, נסה שוב או מאוחר יותר',
            },
            footer: {
                powered_by: 'מופעל על ידי',
                terms_and_conditions: 'תנאים והגבלות',
                privacy: 'מדיניות פרטיות',
                cookie: 'מדיניות עוגיות',
            },
        },
        pages: {
            payment_completed: {
                title: 'התשלום שלך עובד. תודה על ההזמנה!',
                subtitle: 'פרטי ההזמנה נשלחו לכתובת הדוא"ל שלך.',
                back_to_menu: 'חזרה לתפריט',
                close_tab: 'סגור לשונית זו',
            },
            payment_failed: {
                title: 'לצערנו אירעה שגיאה בעיבוד התשלום.',
                subtitle: '',
                back_to_menu: 'חזרה לתפריט',
                close_tab: 'סגור לשונית זו',
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: 'קבלה להזמנת שולחן',
            details: {
                datetime: 'הזמנה ל',
                number_of_people: 'מספר אנשים',
                placed: 'הוזמן',
                updated: 'עודכן לאחרונה',
                notes: 'הערות',
                name: 'שם',
                email: 'דוא"ל',
                phone: 'טלפון',
                store_address: 'כתובת החנות',
            },
            status_update: {
                title: 'הזמנה {{number}} עודכנה',
                body: 'סטטוס ההזמנה שלך עודכן ל-{{status}}',
            },
            email_common: {
                name: 'שם: {{name}}',
                phone: 'טלפון: {{number}}',
                number_of_people: 'מספר אנשים: {{number}}',
                date: 'תאריך: {{date}}',
                time: 'שעה: {{time}}',
                location: 'מיקום החנות: {{name}}',
                notes: 'הערות: {{name}}',
            },
            email_new_booking_restaurant: {
                subject: 'הזמנה שולחן חדש {{number}} מאת {{name}}',
                powered_by: 'מופעל על ידי {{name}}',
                overview: 'בקשת הזמנה שולחן חדש',
                title: 'הזמנה חדשה עבור {{name}}',
                subtitle: 'מספר הזמנה {{number}}',
                description_confirmed: 'ההזמנה אושרה אוטומטית. ניתן לבטל אותה דרך לוח הבקרה והלקוח יקבל הודעה בדוא"ל',
                description_unconfirmed: 'אשר או בטל את ההזמנה דרך לוח הבקרה',
                url_pre_text: 'צפה ועדכן ב',
            },
            email_new_booking_customer: {
                subject: 'בקשת הזמנה שולחן',
                powered_by: 'מופעל על ידי {{name}}',
                overview: 'בקשת הזמנה שולחן חדש',
                title: 'תודה על ההזמנה',
                subtitle: 'מספר הזמנה {{number}}',
                description: '<b>תקבל דוא"ל נוסף כאשר ההזמנה שלך תאושר או תידחה.</b><br>צור קשר לשינויים בהזמנה. פרטי ההזמנה שלך:',
                url_pre_text: 'ניתן לצפות בקבלת ההזמנה בזמן אמת ב',
            },
            email_update_booking_customer: {
                subject_confirmed: 'הזמנה שולחן אושרה',
                subject_unconfirmed: 'הזמנה שולחן בוטלה',
                powered_by: 'מופעל על ידי {{name}}',
                overview: 'בקשת הזמנה שולחן',
                title_confirmed: 'ההזמנה אושרה',
                title_unconfirmed: 'ההזמנה בוטלה',
                subtitle: 'מספר הזמנה {{number}}',
                description_confirmed: 'נשמח לראותך. צור קשר לבקשת שינויים בהזמנה',
                description_unconfirmed: 'לצערנו לא ניתן לקבל את בקשת ההזמנה. מתנצלים על אי הנוחות. צור קשר אם יש לך שאלות',
                url_pre_text: 'ניתן לצפות בקבלת ההזמנה בזמן אמת ב',
            },
            email_status_update_customer: {
                subject: 'הזמנה #{{number}} – {{subjectLabel}}',
                body: 'ההזמנה שלך #{{number}} ב-{{store}} היא כעת {{status}}.',
            },
            errors: {},
            status_warning: 'עדכן את סטטוס ההזמנה בלוח הבקרה בדף ההזמנות',
        },
    },
    email_delayed_order: {
        subject: 'הזמנה #{{number}} – {{subjectLabel}}',
        header: 'זמן הכנה מעודכן',
        title: 'זמן הכנה מעודכן',
        order_number: 'מספר הזמנה: {{number}}',
        description: 'ההזמנה שלך תהיה מוכנה ב-{{time}}.',
        order_time_updated_to: 'זמן ההזמנה שלך עודכן.',
        powered_by: 'מופעל על ידי {{name}}',
        button_text: 'עקוב אחר הזמנה',
        subject_label: 'זמן הכנה מעודכן',
        subject_label_delivery: 'זמן משלוח מעודכן',
        body_ready: 'ההזמנה שלך תהיה מוכנה ב-{{time}}.',
        body_delivery: 'ההזמנה שלך תימסר ב-{{time}}.',
    },
    order: {
        receipt: {
            est_ready_time: 'זמן מוכנות משוער',
            est_driver_pickup_time: 'זמן איסוף נהג משוער',
            est_delivery_time: 'זמן משלוח משוער',
            tab_details: 'פרטים',
            tab_dishes: 'פריטים',
            future_order: 'הזמנה עתידית',
            reprint: 'הדפסה חוזרת',
            details: {
                order_no: 'מס\' הזמנה',
                status: 'סטטוס',
                placed: 'הוזמן',
                due: 'מועד',
                due_asap: 'עכשיו / בהקדם',
                last_updated: 'עודכן לאחרונה',
                total: 'סה"כ',
                type: 'סוג',
                origin: 'מקור',
                table: 'שולחן',
                number_of_people: 'מספר אנשים',
                payment_method: 'אמצעי תשלום',
                payment_status: 'סטטוס תשלום',
                payment_currency: 'מטבע תשלום',
                notes: 'הערות',
                name: 'שם',
                email: 'דוא"ל',
                phone: 'טלפון',
                distance: 'מרחק',
                driving_time: 'זמן נסיעה',
                delivery_zone: 'אזור',
                delivery_address: 'כתובת משלוח',
                delivery_provider: 'ספק משלוחים',
                delivery_tracking: 'מעקב משלוח',
                delivery_return_tracking: 'מעקב החזרה',
                delivery_tracking_link: 'עקוב אחר הזמנה',
                tookan_status: 'סטטוס Tookan',
                tookan_status_failed_book: 'הזמנה משלוח נכשלה',
                tookan_status_failed_update: 'עדכון ההזמנה נכשל',
                tookan_status_success: 'הוזמן למשלוח',
                store_address: 'כתובת החנות',
                destination: 'יעד',
                estimated_arrival_time: 'זמן הגעה משוער',
                delivery_status: 'סטטוס',
                delivery_track_your_order: 'עקוב אחר ההזמנה שלך',
                delivery_text: 'משלוח',
                arrival_date: 'תאריך הגעה',
            },
            dishes: {
                headings: {
                    quantity: 'כמות',
                    item: 'פריט',
                    price: 'מחיר',
                },
                notes: 'הערות',
                remove_ingredients: 'הסר מרכיבים',
            },
            status_update: {
                title: 'הזמנה {{number}} עודכנה',
                body: 'סטטוס ההזמנה שלך עודכן ל-{{status}}',
            },
            wait_time_update: {
                title: 'הזמנה {{number}} עודכנה',
                body: 'מועד ההזמנה שלך עודכן',
            },
            delivery_update: {
                title: 'הזמנה {{number}} עודכנה',
                body: 'ההזמנה שלך הוזמנה למשלוח. ראה קישור מעקב בזמן אמת',
            },
            payment_status_update: {
                title: 'הזמנה {{number}} עודכנה',
                body: 'סטטוס התשלום של ההזמנה עודכן.',
            },
            email_new_order_restaurant: {
                subject: 'הזמנה חדשה ({{number}}) - {{name}}',
                powered_by: 'מופעל על ידי {{name}}',
                overview: 'הודעה על הזמנה חדשה',
                title: 'הזמנה חדשה ב-{{name}}',
                subtitle: 'מספר הזמנה {{number}}',
                description: 'צפה בפרטים ועדכונים דרך לוח הבקרה',
                button_text: 'עקוב אחר הזמנה',
                track_delivery_button_text: 'עקוב אחר משלוח',
            },
            email_new_order_customer: {
                subject: 'קבלת הזמנה ({{number}})',
                powered_by: 'מופעל על ידי {{name}}',
                overview: 'הודעה על הזמנה חדשה',
                title: 'הזמנה חדשה ב-{{name}}',
                subtitle: 'מספר הזמנה {{number}}',
                description: 'צפה בפרטים ועדכונים בקבלה האונליין בזמן אמת',
                button_text: 'עקוב אחר הזמנה',
                track_delivery_button_text: 'עקוב אחר משלוח',
            },
            email_order_completed_by_customer: {
                subject: 'הזמנה ({{number}}) הושלמה על ידי הלקוח',
                powered_by: 'מופעל על ידי {{name}}',
                overview: 'הודעה על השלמת הזמנה',
                title: 'הזמנה הושלמה ב-{{name}}',
                subtitle: 'מספר הזמנה {{number}}',
                description: 'צפה בפרטים ועדכונים של ההזמנה דרך לוח הבקרה או בקבלה ב',
            },
        },
        totals: {
            tax: '{{name}} ({{percent}}%)',
            tax_in_prices: '{{name}} ({{percent}}%) כלול במחיר',
            fee: '{{name}} ({{value, currency}} + {{percent}}%)',
            fee_percent: '{{name}} ({{percent}}%)',
            fee_fixed: '{{name}}',
            delivery_fee: 'דמי משלוח',
            delivery_fee_offset: 'הנחה על דמי משלוח',
            delivery_fee_total: 'סה"כ דמי משלוח',
            promo: 'הנחה: {{name}} ({{value, currency}} + {{percent}}% הנחה)',
            promo_percent: 'הנחה: {{name}} ({{percent}}%)',
            promo_fixed: 'הנחה: {{name}}',
            promo_none: 'הנחה: {{name}}',
            cart: 'עגלת קניות',
            tip: 'טיפ להזמנה',
            total: 'סה"כ',
        },
        status: {
            unconfirmed: 'לא מאושר',
            awaiting_payment: 'ממתין לתשלום',
            confirmed: 'מאושר',
            ready: 'מוכן',
            on_route: 'בדרך',
            complete: 'הושלם',
            cancelled: 'בוטל',
            seated: 'הושבו',
        },
        searching: {
            lalamove_search_placeholder: 'חפש הזמנה לפי מזהה משלוח Lalamove',
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: 'לא זמין',
                },
            },
            dish: {
                no_stock: 'אזל מהמלאי',
                not_available: 'לא זמין',
            },
        },
    },
    admin: {
        registration: {
            register_confirmation_code_subject: 'קוד אימות בדוא"ל',
            register_confirmation_code_email: 'קוד האימות שלך הוא {{confirmation_code}} (פג תוקף בעוד 24 שעות)',
            register_confirmation_code_email_onbehalf: 'קוד האימות שלך הוא {{confirmation_code}} (פג תוקף בעוד 24 שעות). זה עבור כתובת הדוא"ל {{email}}.',
        },
    },
};
//# sourceMappingURL=he.js.map